import { mapPinType } from '../../constants';
import { handleChooseHotelRoomButtonClick } from '../../HotelComponent/ChooseHotelRoomButton';
export const getMapPinOnClickHandler = props => {
  if ((props === null || props === void 0 ? void 0 : props.type) === mapPinType.HOTEL) {
    const {
      hotelDetailURL,
      hotel,
      args
    } = props;
    return handleChooseHotelRoomButtonClick({
      hotelId: hotel === null || hotel === void 0 ? void 0 : hotel.hotelId,
      args,
      detailURL: hotelDetailURL,
      clickedOnMap: 'Y'
    });
  }
  return () => {};
};